export default __webpack_public_path__ + "static/blob-rhs-5ab62bb9e2b48aebafcfea6425d1e151.png";